//library
import React, {useEffect, useRef} from 'react';
import styled, { useTheme } from 'styled-components';

//components
import {
  Nav,
  NavLink,
  NavbarContainer,
  ClubLogo,
  NavItems,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
} from './NavbarStyledComponent';

//Logo
import NirmanLogo from "../../images/Logo.png"
//icons
import { FaBars , FaTimes } from 'react-icons/fa'; 
import { LocalPostOfficeSharp } from '@mui/icons-material';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const navbarRef = useRef(null);

  // Function to scroll to the About section
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false); // Close mobile menu after clicking on About
  };

  useEffect(() => {
    let lastScrollTop = 0;
    const navbar = navbarRef.current; // Access the navbar through the ref

    const handleScroll = () => {
      let scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        // Scrolling down - hide navbar
        if (navbar) {
          navbar.style.top = "-80px";
        }
      } else {
        // Scrolling up - show navbar
        if (navbar) {
          navbar.style.top = "0";
        }
      }
      lastScrollTop = scrollTop;
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up event listener
    };
  }, []);

  return (
    <Nav id="navbar" ref={navbarRef}>
      <NavbarContainer>
        <img src = {"images/Logo3.png"} style={{
          
        }}>
        </img>
      </NavbarContainer >

      <NavbarContainer marginLeft = {"Auto"}>

        <NavItems>
          <NavLink href="#about" onClick={scrollToAbout}>About</NavLink>
          <NavLink href='#events'>Events</NavLink>
          <NavLink href='#timeline'>TimeLine</NavLink>
          <NavLink href='#past'>Past Events</NavLink>
          <NavLink href='#skills'>Sponsors</NavLink>
        </NavItems>
        

        <MobileIcon onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </MobileIcon>

        
        
        <ButtonContainer>
        </ButtonContainer>

        {    
          isOpen &&
          <MobileMenu isOpen={isOpen}>
            <MobileLink href="#about" onClick={() => setIsOpen(!isOpen)}>About</MobileLink>
            <MobileLink href='#events' onClick={() => setIsOpen(!isOpen)}>Events</MobileLink>
            <MobileLink href='#timeline' onClick={() => setIsOpen(!isOpen)}>TimeLine</MobileLink>
            <MobileLink href='#past' onClick={() => setIsOpen(!isOpen)}>Past-Events</MobileLink>
            <MobileLink href='#skills' onClick={() => setIsOpen(!isOpen)}>Sponsors</MobileLink>
          </MobileMenu>
        }
        

      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
